export default {
  HABITS_RECOMMENDED_BUDGET_CALCULATION_REPOSITORY: Symbol.for('HABITS_RECOMMENDED_BUDGET_CALCULATION_REPOSITORY'),
  CREATE_HABITS_RECOMMENDED_BUDGET_CALCULATION_COMMAND: Symbol.for('HABITS_RECOMMENDED_BUDGET_CALCULATION_COMMAND'),
};
